import { render, staticRenderFns } from "./informList.vue?vue&type=template&id=bf1c0672&scoped=true&"
import script from "./informList.vue?vue&type=script&lang=js&"
export * from "./informList.vue?vue&type=script&lang=js&"
import style0 from "./informList.vue?vue&type=style&index=0&id=bf1c0672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1c0672",
  null
  
)

export default component.exports